$(document).ready(function () {
    $('.slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199.98,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 991.98,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '20px',
                }
            },
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.mobile-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    });

    $('input[name="phone"]').mask('+7 (999) 999-99-99');

    $('.select-preview').on('click', function (event) {
        event.preventDefault();
        var mainView = $('.make-preview');
        var clickedImage = $(this).find('img').attr('src');
        var changedImage = getCurrentImagePreview(clickedImage);

        mainView.css('background-image', 'url(' + changedImage + ')').fadeIn();

    });

    getCurrentImagePreview = type => {
        let currentView;

        switch (type) {
            case './img/make2.png':
                currentView = '../img/hard.jpg';
                break;
            case './img/make3.png':
                currentView = '../img/man.jpg';
                break;
            case './img/make4.png':
                currentView = '../img/car.jpg';
                break;
            case './img/make5.png':
                currentView = '../img/glass.jpg';
                break;
            case './img/make6.png':
                currentView = '../img/work.jpg';
                break;
            case './img/make7.png':
                currentView = '../img/group.jpg';
                break;

        }
        return currentView;
    };

    $('.prod_item').on('click', function (event) {
        event.preventDefault();
        let currentFormName = $(this).find('.prod-title').text();
        $('#price').find('input[name="forma"]').val(currentFormName);

        $('#price').on($.modal.AFTER_CLOSE , function() {
            $('#price').find('input[name="forma"]').val('');
        });

        $('#price').modal({
            showClose: false
        });
    });

    $('.conf').on('click', function (event) {
        event.preventDefault();
        $('#conf').modal({
            showClose: false
        });
    });

    $('.footer-conf').on('click', function (event) {
        event.preventDefault();
        $('#conf').modal({
            showClose: false
        });
    });

    $(function () {

        add_antispamcheck();
        check_mobile();
        timer_antispamcheck();

        $("form").submit(function (event) {
            event.preventDefault();
            form = $(this);
            flag = true;

            form.find('input[name="phone"]').is(function () {
                phone = form.find('input[name="phone"]').val();
                phoneC = form.find('input[name="phone"]');
                if (phoneC.hasClass('error')) { phoneC.removeClass('error'); }
                var phoneReg = /^[+() 0-9 -]{7,}$/;
                if (!phoneReg.test(phone)) {
                    flag = false;
                    phoneC.addClass('error');
                    form.find('input[name="phone"]').val('Введите номер телефона');
                }
            });

            if (flag) {
                var form_data = $(this).serialize();
                $.ajax({
                    type: "POST",
                    url: "sendit.php",
                    data: form_data,
                    success: function () {
                        $('input:not([name="forma"])').val('').empty();
                        $.modal.close();
                        $('#ty').modal({
                            showClose: false
                        });
                        event.preventDefault();
                    }
                });
            }
            return false;
        });

        function add_antispamcheck() {
            $("form").each(function () {
                $(this).append("<input type='hidden' value='0' name='time_spend'>");
            });
        }

        function check_mobile() {

            var isMobile = {
                Android: function () { return navigator.userAgent.match(/Android/i) ? true : false; },
                BlackBerry: function () { return navigator.userAgent.match(/BlackBerry/i) ? true : false; },
                iOS: function () { return navigator.userAgent.match(/iPhone|iPad|iPod/i) ? true : false; },
                Windows: function () { return navigator.userAgent.match(/IEMobile/i) ? true : false; },
                any: function () { return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows()); }
            };

            $("form").each(function () {
                $(this).append("<input type='hidden' value='" + isMobile.any() + "' name='mobile'>");
            });
        }

        function timer_antispamcheck() {
            $('form input[name="time_spend"]').each(function () {
                var value = $(this).val();
                value++;
                $(this).val(value);
            });
            setTimeout(timer_antispamcheck, 1000);
        }
    });
});
